const FormMethodEnum = Object.freeze({
    ShortAnswer: 1,
    MultipleChoice: 2,
    Checkboxes: 3,
    Dropdown: 4,
    Rating: 5,
    number: 6,
    YesNo: 7,
    Date: 8,
    TextArea: 9,
    BipolarMatrix: 10,
    PredefineDropdown: 11,
    Image: 12,
    VedioLink: 13,
    NPS: 14,
    Maps: 15,
    Label: 16,
    HijriDate: 17,
    PhoneNumber: 18,
    EmailInput: 19,
    PictureChoice: 20,
    ContactForm: 21,
    Url: 22,
    UploadFiles: 23,
    Consent: 24,
    Ranking: 25,
    TextEditor: 26,
    TrickyQuestion: 27,
    CSAT5: 28,
    CSAT3: 29,
    PrecisedCheckboxes: 30,
    OrderedAnswers: 31
})

const ProcessTypesEnum = Object.freeze({
    SurveyApproval: 1,
    InternalSurveys: 2,
    Inquiry: 3,
    StrategicSatisfaction: 4,
    OperationalIndicator: 5,
    AdditionalAnalysis: 6,
    ScientificConsultation: 7,
    FocusGroups: 8,
})

const FieldTypesEnum = Object.freeze({
    Textfield: 1,
    Checkbox: 2,
    Radio: 3,
    Select: 4,
    Date: 5,
    Textarea: 6,
    Masters: 7
})

const ActivityTypesEnum = Object.freeze({
    StartActivity: 1,
    TaskActivity: 2,
    WaitActivity: 3,
    CodeActivity: 4,
    EndActivity: 5,
    CTSActivity: 7,
})

const ActivityClassTypesEnum = Object.freeze({
    StartActivity: 2,
    TaskActivity: 7,
    EndActivity: 6,
})

const OwnerTypes = Object.freeze({
    User: 1,
    Role: 2,
    CustomRole: 3,
    Structure: 4,
    Initiator: 5,
    CustomUser: 6

})

const AccountTypes = Object.freeze({
    User: 1,
    Role: 2
})
const AnalyticsTypes = Object.freeze({
    Baladi: 1,
    Sakani: 2
})
const ResultTypes = Object.freeze({
    Gender: 1,
    Nationality: 2,
    AgeGroup: 3,
    EducationalLevel: 4,
    Publication: 5,
    Heat: 6,
    HeatIntishar: 7,
    CSAT : 8,
    Filter: 9,
    Profession: 10,
    SignedQuestion: 13,
    CommunicationReason: 14,
    PreCommunication: 15,
    TripleSatisfaction: 16,
    NPS: 17,
    Endorsment: 18,
    CSAT51 : 19,
    CSAT5Amanat: 20,
    Reservation: 21,
    CSAT2: 22,
    Awareness: 23,
    Regions: 24
})
const PermissionLevelsEnum = Object.freeze({
    User: 1,
    Role: 2,
    Department: 3,
    Everyone: 4

})


const PermissionsMatrixEnum = Object.freeze({
    Full: 1,
    Read: 2,
    Write: 3
})



const PermissionTypesEnum = Object.freeze({
    Menu: 1,
    Survey: 2,
    Process: 3,
    Elibrary: 4,
    ElibraryCategory: 5
})

const PermissionsEnum = Object.freeze({


})

const SurveyStatusEnum = Object.freeze({
    Draft: 1,
    Pending: 2,
    Approved:3
})

export {
    FormMethodEnum, FieldTypesEnum, OwnerTypes, ActivityTypesEnum, ActivityClassTypesEnum, PermissionLevelsEnum, PermissionTypesEnum, AccountTypes, PermissionsMatrixEnum, PermissionsEnum, ProcessTypesEnum, SurveyStatusEnum, AnalyticsTypes, ResultTypes
}